'use client';
import { jsx, Fragment, jsxs } from '@emotion/react/jsx-runtime';
import { Stack } from '@s7/layout';
import { rem } from '@s7/styles';
import { Typography } from '@s7/ui';

var headingStyles = function(theme) {
    var _obj;
    return _obj = {
        paddingLeft: rem(24)
    }, _obj[theme.fn.up("md1")] = {
        paddingLeft: rem(40)
    }, _obj;
};
var SearchLayoutBlock = function(props) {
    var children = props.children, title = props.title;
    if (!title) {
        return /*#__PURE__*/ jsx(Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ jsxs(Stack, {
        children: [
            /*#__PURE__*/ jsx(Typography, {
                sx: headingStyles,
                variant: "heading",
                children: title
            }),
            children
        ]
    });
};

export { SearchLayoutBlock };
